import type { Message, ChatContext } from '../../../types/models';
import type { GroqMessage } from './types';
import { extractThinkingContent } from '../../../components/ThinkingBlock';

export function formatMessages(
  message: string,
  context: ChatContext,
  previousMessages: Message[]
): GroqMessage[] {
  const messages: GroqMessage[] = [];

  // Add system message if present
  if (context.systemPrompt) {
    messages.push({
      role: 'system',
      content: context.systemPrompt
    });
  }

  // Add previous messages
  previousMessages.forEach(msg => {
    messages.push({
      role: msg.role,
      content: extractThinkingContent(msg.content)
    });
  });

  // Add the new message
  messages.push({
    role: 'user',
    content: message
  });

  return messages;
}